import router from '../../router'

const setFilterMutation = (store, moduleName) => {
    // Function to check if a mutation exists
    const mutationExists = (mutation) => !!store._mutations[mutation]

    // Set filter with namespaced mutation if exists
    const namespaceMutation = `${moduleName}/SET_FILTER`
    if (mutationExists(namespaceMutation)) {
        return namespaceMutation
    }

    // Fallback to regular mutation if namespaced mutation does not exist
    const mutation = `SET_${moduleName.toUpperCase()}_FILTER`
    if (mutationExists(mutation)) {
        return mutation
    } else {
        console.warn(`Mutation ${namespaceMutation} and ${mutation} do not exist in the store.`)
    }
}

const resetFilterMutation = (store, moduleName) => {
    // Function to check if a mutation exists
    const mutationExists = (mutation) => !!store._mutations[mutation]

    // Set filter with namespaced mutation if exists
    const namespaceMutation = `${moduleName}/RESET_FILTERS`
    if (mutationExists(namespaceMutation)) {
        return namespaceMutation
    }

    // Fallback to regular mutation if namespaced mutation does not exist
    const mutation = `RESET_${moduleName.toUpperCase()}_FILTERS`
    if (mutationExists(mutation)) {
        return mutation
    } else {
        console.warn(`Mutation ${namespaceMutation} and ${mutation} do not exist in the store.`)
    }
}

export const filters = {
    state: {
        status: 'idle',
        filterName: '',
        userFilters: [],
        selectedUserFilter: '',
        initLoad: false
    },
    mutations: {
        SET_FILTERS_STATUS(state, status) {
            state.status = status
        },
        SET_USER_FILTERS(state, payload) {
            state.userFilters = payload
        },
        SET_FILTER_NAME(state, payload) {
            state.filterName = payload
        },
        SET_USER_FILTER(state, payload) {
            state.selectedUserFilter = payload
        },
        PUSH_FILTER(state, payload) {
            state.userFilters.push(payload)
        },
        SET_USER_FILTERS_INIT_LOAD(state, payload) {
            state.userFiltersInit = payload
        }
    },
    actions: {
        setUserFilter({ commit }, payload) {
            commit('SET_USER_FILTER', payload)
        },
        setFilter({ commit, dispatch }, payload) {
            const { groupName, moduleName } = payload

            // set group filters
            dispatch('setGroupFilters', { groupName, moduleName })

            // set filter
            commit(setFilterMutation(this, moduleName), payload)
        },
        setGroupFilters({ commit, getters }, { groupName, moduleName }) {
            if (!groupName) return

            const getter = `get${moduleName[0].toUpperCase() + moduleName.slice(1)}Filters`
            const filters = getters[getter]

            for (const [key, value] of Object.entries(filters)) {
                if (value.groupName === groupName) {
                    commit(setFilterMutation(this, moduleName), {
                        filter: key,
                        value: false,
                        moduleName
                    })
                }
            }
        },
        setFilters({ commit }, { filters, moduleName }) {
            commit(resetFilterMutation(this, moduleName), filters)
        },
        setFilterName({ commit }, payload) {
            commit('SET_FILTER_NAME', payload)
        },
        sendFilters({ state, commit, getters }, payload) {
            /* First letter uppercase */
            const getter = `get${payload[0].toUpperCase() +
                payload.slice(1)}Filters`

            const promoFilters = getters[getter]
            const userFilters = {}
            for (const [key, value] of Object.entries(promoFilters)) {
                if (value?.value !== undefined) {
                    userFilters[key] = value.value
                }
            }
            const filter = {
                filters: userFilters,
                id: getters.authUser.id,
                name: state.filterName
            }
            const foundFilter = state.userFilters.findIndex(
                el => el.name === filter.name
            )
            if (foundFilter !== -1) {
                state.userFilters[foundFilter] = filter
            } else {
                commit('PUSH_FILTER', filter)
            }
            return this.$api.put('filters', filter)
        },
        setUserFilters({ state, commit, dispatch, getters }, payload) {
            const userFilters = state.userFilters.find(
                item => item.id === payload.id
            )?.filters
            const promoFilters = JSON.parse(
                JSON.stringify(getters.getPromotionsFilters)
            )
            for (const [key, value] of Object.entries(userFilters)) {
                promoFilters[key].value = value
            }
            commit('RESET_PROMOTIONS_FILTERS', promoFilters)
        },
        removeUserFilter({ state, commit, dispatch }, payload) {
            return this.$api
                .delete(`deleteFilter/${payload.id}`, {
                    config: {
                        noCancel: true
                    }
                })
                .then(res => {
                    if (res.data.message === 'Filter deleted!') {
                        if (payload.noNotification) return
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Usunięto filtr'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: res.data.message
                        })
                    }
                })
        },

        async loadUserFilters({ commit, dispatch, getters }) {
            return this.$api
                .get(`filters/${getters.authUser.id}`)
                .then(response => {
                    const responseData = response.data.data
                    const userFilters = []
                    responseData.forEach(filterObj => {
                        let breakLoop = false
                        for (const filter of Object.keys(filterObj.filters)) {
                            if (!getters.getPromotionsFilters[filter]) {
                                dispatch('removeUserFilter', {
                                    id: filterObj.id,
                                    noNotification: true
                                })
                                breakLoop = true
                                break
                            }
                        }
                        if (breakLoop) return
                        const filters = {}
                        for (const [key, value] of Object.entries(
                            filterObj.filters
                        )) {
                            if (value !== undefined) {
                                filters[key] = value
                            }
                        }
                        userFilters.push({
                            filters,
                            id: filterObj.id,
                            name: filterObj.name
                        })
                    })
                    commit('SET_USER_FILTERS', userFilters)
                })
                .catch(error => {
                    console.log(error)
                })
        },

        async clearFilters({ commit, dispatch }, payload) {
            const initState = await this.$storage.getItem('initialState')

            commit(resetFilterMutation(this, payload), initState[payload].filters)
            commit('SET_FILTER_NAME', '')
            dispatch('setUserFilter', '')
        },
        setFilterQueryParams(_, payload) {
            const { filters } = payload
            const params = {}
            const promoState = payload?.promoState || router.currentRoute.name

            for (const [name, filterObj] of Object.entries(filters)) {
                if (filterObj.notToSend) continue
                const editedName = []
                const val = filterObj.value
                const isArray = Array.isArray(val)
                if ((isArray && val.length) || (!isArray && !!val)) {
                    if (promoState === 'promo-finished') {
                        editedName.push(
                            `_group[1][${name.replaceAll('|', '.')}]`
                        )
                        editedName.push(
                            `_group[2][${name.replaceAll('|', '.')}]`
                        )
                        editedName.push(
                            `_group[3][${name.replaceAll('|', '.')}]`
                        )
                    } else {
                        editedName.push(name)
                    }
                    editedName.forEach(el => {
                        params[el] = val
                        if (isArray && filterObj.expectedType === 'string') {
                            params[el] = val.join(',')
                        } else {
                            params[el] = val
                        }
                    })
                }
            }
            return params
        }
    },
    getters: {
        getFilters: state => {
            return state.filters
        },
        getUserFilters: state => {
            return state.userFilters
        },
        getUserFiltersForSelect: state => {
            if (state.userFilters) {
                return state.userFilters.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
            }
        },
        getFilterName: state => {
            return state.filterName
        },
        filtersStatus: state => {
            return state.status
        },
        getUserFilter: state => {
            return state.selectedUserFilter
        },
        getUserFiltersInit: state => state.initLoad
    }
}
